import React, {useEffect} from "react";
import { useTranslation } from "react-i18next";

const LanguageSelector: React.FC = () => {
  const { i18n } = useTranslation();

  // 组件加载时从 localStorage 读取语言设置
  useEffect(() => {
    const savedLanguage = localStorage.getItem("userLanguage");
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  }, [i18n]);

  const handleLanguageChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const selectedLanguage = event.target.value;
    // 保存语言选择到 localStorage
    localStorage.setItem('userLanguage', selectedLanguage);
    i18n.changeLanguage(selectedLanguage);
  };

  return (
    <div style={{ display: "flex", alignItems: "center", margin: 0 }}>
      <select
        onChange={handleLanguageChange}
        value={i18n.language}
        style={{
          padding: "5px",
          fontSize: "16px",
          borderRadius: "5px",
          border: "1px solid #ccc",
        }}
      >
        <option value="en">English</option>
        <option value="zh">中文</option>
      </select>
    </div>
  );
};

export default LanguageSelector;
